import { REFERRAL_ID_QUERY_PARAM } from '../auth';

function readReferralFrontendUrl(): string | null {
  const frontendUrl = import.meta.env.VITE_FRONTEND_URL?.trim();

  return frontendUrl ? frontendUrl : null;
}

export function resolveEmployeeReferralLink(
  userId: number | null,
): string | null {
  if (userId === null || !Number.isSafeInteger(userId) || userId < 1) {
    return null;
  }

  const frontendUrl = readReferralFrontendUrl();

  if (!frontendUrl) {
    return null;
  }

  const referralUrl = new URL('/', frontendUrl);
  referralUrl.searchParams.set(REFERRAL_ID_QUERY_PARAM, String(userId));

  return referralUrl.toString();
}
